<template>
    <div class="top">
        <div class="start">
            <img src="../../../static/img/00.jpg" class="start_img">
            <div class="btn">
               <img src="../../../static/img/000.png" @click="go">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {    
            
        }
    },
    methods: {
        go() {
            this.$router.push({
                name: "shouye"
            });
        }
    },
}
</script>
<style lang="scss" scoped="scoped">
    .top {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
    }
     .top img {
         width: 100%;
         height: 100%;
     }
     .start {
         position: relative;
     }
     .btn {
        position: absolute;
        top: 8%;
        right: -7%;
     }
     .btn img {
         width: 60%;
         height: auto;
         cursor: pointer;
     }
     @media screen and (max-width: 1400px) {
         .btn {
            position: absolute;
            top: 8%;
            right: -12%;
        }
          .btn img {
            width: 50%;
            height: auto;
        }
     }
    @media screen and (max-width: 1600px) {
        .btn {
            position: absolute;
            top: 8%;
            right: -12%;
        }
          .btn img {
            width: 50%;
            height: auto;
        }
     }
    .start_img {
        min-height: 720px;
    }
</style>    


// WEBPACK FOOTER //
// src/components/start/start.vue